var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30225 2.3931H2.6691C2.14576 2.3931 1.72151 2.81735 1.72151 3.34069V9.97383C1.72151 10.4972 2.14576 10.9214 2.6691 10.9214H9.30225C9.82559 10.9214 10.2498 10.4972 10.2498 9.97383V3.34069C10.2498 2.81735 9.82559 2.3931 9.30225 2.3931Z",
    stroke: "#8A8587",
    strokeWidth: 0.947592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCheck);
export default __webpack_public_path__ + "static/media/empty_check.c56bc89b4c93779d47300fa3506fbe6d.svg";
export { ForwardRef as ReactComponent };